import type RootStore from "stores/RootStore";
import type ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const QRScannerRoute: RouteType = {
  name: "QR Scanner",
  path: "/production/scan",
  title: "QR Scanner",
  layout: "/app",
  group: "Production",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "QR Scanner",
      component: () => import("./QRScanner.Header"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./QRScanner.Body"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    try {
      const promises: Promise<unknown>[] = [];
      const projectsStore = (rootStore as unknown as { projectsStore?: ServiceStore })
        .projectsStore;
      if (projectsStore?.find) {
        promises.push(projectsStore.find());
      }
      const usersStore = (rootStore as unknown as { usersStore?: ServiceStore })
        .usersStore;
      if (usersStore?.find) {
        promises.push(usersStore.find());
      }
      const panelsStore = (rootStore as unknown as { panelsStore?: ServiceStore })
        .panelsStore;
      if (panelsStore?.find) {
        promises.push(panelsStore.find());
      }
      await Promise.all(promises);
    } catch (err) {
      console.warn("[QRScannerRoute] beforeEnter preload error:", err);
    }
    return true;
  },
};

export default QRScannerRoute;
